import { sendTimeData } from "../api/v1Export";
import { TimeEntryData } from "../interfaces/V1Interface";
// Function to push time entries back to v1
const pushTimeData = async (timesPayload: { times: TimeEntryData[] }): Promise<any> => {

    try {
        // Make the API request to push back time entry data
        const apiResults = await sendTimeData(timesPayload);

        // Log the API results for debugging purposes
        console.log(apiResults);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Export Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Log the authData for debugging purposes
        console.log(authData);

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the push
        console.error("Error in sendTimeData", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Export the pushTimeData function to be used in other parts of the application
export { pushTimeData };
